import { useMutation } from 'react-query';
import { Button, EyeOffIcon, EyeOpenIcon, Icon, Pane, Spinner, Text } from 'evergreen-ui';
import { useState } from 'react';
import { InputField, Support } from '../../components';
import loginRequest from '../../queries/authenticate';
import { useDispatch } from 'react-redux';
import { setToken, setUser } from '../../store/authSlice';
import { Logo } from '../../components';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import usePasswordVisibility from '../../hooks/passwordVisibility';

export const StyledShadow = styled(Pane)`
  position: absolute;
  top: -40px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #a7aaac;
  width: 320px;
  height: 320px;
  background: radial-gradient(
    50% 50% at 50% 50%,
    rgba(29, 136, 197, 0.1) 0%,
    rgba(29, 136, 197, 0.063) 26.04%,
    rgba(29, 136, 197, 0.04) 50.52%,
    rgba(29, 136, 197, 0) 100%
  );
  border-radius: 320px;
  font-size: 16px;
  font-weight: 500;
`;

const StyledButton = styled(Button)`
  background-color: #e78850;
  :hover {
    background-color: #e78850 !important;
  }
  :pressed {
    background-color: #c78850 !important;
  }
`;

const FormContainer = styled(Pane)`
  width: 100%;

  label {
    font-size: 14px;
    color: #a7aaac;
    margin-bottom: -5px;
  }
`;
const StyledEye = styled.div`
  position: absolute;
  right: 0;
  bottom: 0;
  width: 64px;
  height: 96px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  let navigate = useNavigate();
  const dispatch = useDispatch();

  const [passwordVisibility, togglePasswordVisibility] = usePasswordVisibility();

  const loginQuery = useMutation(loginRequest, {
    useErrorBoundary: true,
    onSuccess: async data => {
      if (!data) return;
      try {
        localStorage.setItem('gk_token', data.jwt);
      } catch (error) {
        console.log(error);
      }

      if (!data.user.confirmed) {
        navigate('/app/emailVerification', { state: { token: data.jwt, email: data.user.email } });
      } else {
        dispatch(setToken(data.jwt));
        dispatch(setUser(data.user));
        navigate('/app');
      }
    },
  });

  const login = () => {
    loginQuery.mutateAsync({ username, password });
  };
  return (
    <Pane display="flex" flexDirection="column" alignItems="center">
      <Pane display="flex" flexDirection="column" alignItems="center" padding={50} position="relative">
        <StyledShadow />
        <Logo size={170} />
      </Pane>
      <FormContainer display="flex" flexDirection="column" justifyContent="center" height="100%" padding={25} ma>
        <Text color="#fcfdfd" fontWeight="bold" fontSize="18px" paddingBottom="24px">
          Login
        </Text>
        <InputField
          label="Email"
          value={username}
          onChange={e => setUsername(e.target.value)}
          placeholder="Enter username"
          autocapitalize="none"
        />
        <div style={{ position: 'relative' }}>
          <InputField
            label="Password"
            placeholder="Enter password"
            type={passwordVisibility ? 'text' : 'password'}
            value={password}
            onChange={e => setPassword(e.target.value)}
            style={{ paddingRight: 58 }}
            autocapitalize="none"
          />
          <StyledEye>
            {passwordVisibility ? (
              <Icon
                icon={EyeOpenIcon}
                color="#65696C"
                size={24}
                onClick={togglePasswordVisibility}
                style={{ cursor: 'pointer' }}
              />
            ) : (
              <Icon
                icon={EyeOffIcon}
                color="#65696C"
                size={24}
                onClick={togglePasswordVisibility}
                style={{ cursor: 'pointer' }}
              />
            )}
          </StyledEye>
        </div>
        <StyledButton
          appearance="primary"
          marginTop="30px"
          height={58}
          backgroundColor="#e78850"
          border="none"
          borderRadius={10}
          onClick={login}
          disabled={loginQuery.isLoading}
        >
          {loginQuery.isLoading ? (
            <Spinner size={16} />
          ) : (
            <Text color="#fcfdfd" fontWeight="600" fontSize={15} letterSpacing={2}>
              LOGIN
            </Text>
          )}
        </StyledButton>
        <Pane display="flex" alignItems="center" paddingY={30}>
          <Text color="#f0f0f2" fontSize={13}>
            Don’t have an account?
          </Text>
          <Text
            color="#e78850"
            fontSize={14}
            fontWeight={500}
            onClick={() => navigate('/app/register')}
            marginLeft={8}
            cursor="pointer"
          >
            Register
          </Text>
        </Pane>
      </FormContainer>
      <Support iconStyle={{ position: 'absolute', right: 0, bottom: 0 }} email />
    </Pane>
  );
};

export default LoginPage;
